import styled from 'styled-components'

export const StickyArea = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`
